import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const evaluateDisable = (scope, expression) => {
  const evalInScope = (scr, context) => {
    return new Function("with(this) { return " + scr + "}").call(context);
  };
  let result = false;
  try {
    result = evalInScope(expression, scope);
  } catch (e) {
    //On error mantain enabled
  }
  return result;
};
export default {
  /**
   * TODO: This function can be totally generic, will left as it is
   * because time constraints
   */
  bind(el, binding, vNode) {
    var _context;
    const expression = binding.expression;
    const scope = _objectSpread({}, vNode.context.vfjsModel);
    const inputEl = _findInstanceProperty(_context = $(el)).call(_context, ":input,textarea");
    const result = evaluateDisable(scope, expression);
    inputEl.prop("disabled", result);
  },
  update(el, binding, vNode) {
    var _context2, _context3;
    const expression = binding.expression;
    const scope = _objectSpread({}, vNode.context.vfjsModel);
    const result = evaluateDisable(scope, expression);
    const inputEl = _findInstanceProperty(_context2 = $(el)).call(_context2, ":input");
    const textareaEl = _findInstanceProperty(_context3 = $(el)).call(_context3, "textarea");
    const oldInputState = inputEl.prop("disabled");
    const oldTextareaState = textareaEl.prop("disabled");
    inputEl.prop("disabled", result);
    textareaEl.prop("disabled", result);
    if (result != oldInputState) {
      inputEl.each((_index, element) => {
        setTimeout(() => {
          $(element).val("");
          element.dispatchEvent(new Event("input", {
            bubbles: true
          }));
        });
      });
    }
    if (result != oldTextareaState) {
      textareaEl.each((_index, element) => {
        setTimeout(() => {
          $(element).val("");
          element.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        });
      });
    }
  }
};